"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _listSecteurActMultiple = _interopRequireDefault(require("@/components/listSecteurActMultiple"));

var _listClientMultiple = _interopRequireDefault(require("@/components/listClientMultiple"));

var _listEnseigneMultiple = _interopRequireDefault(require("@/components/listEnseigneMultiple"));

var _listSecteurGeoMultiple = _interopRequireDefault(require("@/components/listSecteurGeoMultiple"));

var _listCascaderUtilisateur = _interopRequireDefault(require("@/components/listCascaderUtilisateur"));

var _moment = _interopRequireDefault(require("moment"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiAffaireCalculs = _interopRequireWildcard(require("@/api/affairecalculs"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _vue = _interopRequireDefault(require("vue"));

var _utils = require("@/helpers/utils");

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _fileSaver = require("file-saver");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Rapport-FaePca',
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  components: {
    listSecteurActMultiple: _listSecteurActMultiple.default,
    listClientMultiple: _listClientMultiple.default,
    listEnseigneMultiple: _listEnseigneMultiple.default,
    listSecteurGeoMultiple: _listSecteurGeoMultiple.default,
    listCascaderUtilisateur: _listCascaderUtilisateur.default
  },
  data: function data() {
    var _this = this;

    var validDate = function validDate(rule, value, callback) {
      var d = _this.currentDate || '';

      if (d === '') {
        callback(new Error('Champ obligatoire'));
      }

      if (d !== '' && !(0, _moment.default)(d, 'YYYYMM').isValid()) {
        callback(new Error('Date invalide'));
      }

      callback();
    };

    return {
      refresh: 0,
      refreshEnseigne: 0,
      formData: {},
      rptData: [],
      // ---
      rules: {
        currentDate: {
          required: true,
          validator: validDate
        }
      },
      // ---
      options: [{
        label: 'Tout',
        value: 'not in (\'\')'
      }, {
        label: 'En cours',
        value: 'not in (' + [CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].join(',') + ')'
      }, {
        label: 'En sommeil',
        value: 'in (' + CONST.AFFAIRE.STATUS.SLEEPING.value + ')'
      }, {
        label: 'Archivé',
        value: 'in (' + CONST.AFFAIRE.STATUS.ARCHIVED.value + ')'
      }],
      // ---
      secteursact: [],
      clients: [],
      enseignes: [],
      secteursgeo: [],
      conducteur: null,
      status: [],
      currentDate: null,
      saveDate: null,
      sums: [],
      show: false
    };
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.mixinEvents = {
      export: "RAPPORT_FAE_PCA_EXPORT",
      exported: "RAPPORT_FAE_PCA_EXPORTED"
    };
    apiAffaireCalculs.getLastGestMens(this.user.id_societe).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(result) {
        var savedData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.loadFormData("".concat(_this2.user.id_societe, "-").concat(_this2.$route.name));

              case 2:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = {};

              case 5:
                savedData = _context.t0;

                if (savedData) {
                  _this2.secteursact = savedData.secteursact || [];
                  _this2.clients = savedData.clients || [];
                  _this2.enseignes = savedData.enseignes || [];
                  _this2.secteursgeo = savedData.secteursgeo || [];
                  _this2.conducteur = savedData.conducteur || null;
                  _this2.status = savedData.status || null;
                  _this2.etape = savedData.etape || CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value;
                  _this2.currentDate = savedData.date || null;
                } // --------------------------------------------


                if (!_this2.currentDate) {
                  if (result && result.length > 0) {
                    _this2.currentDate = (0, _moment.default)(result[0].anneemois, 'YYYYMM').subtract(1, 'months').format('YYYYMM');
                  } else {
                    _this2.currentDate = (0, _moment.default)().format('YYYYMM');
                  }
                }

                _this2.saveDate = _this2.currentDate;

                _this2.validateForm();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  filters: {
    toSumMt: function toSumMt(value, column, sums) {
      value = isNaN(value) ? 0 : Number(value);

      if (sums[column] === undefined) {
        sums[column] = Number(value);
      } else {
        sums[column] += Number(value);
      }

      return value;
    },
    toSumPc: function toSumPc(value, column, col1, col2, sums) {
      value = isNaN(value) ? 0 : Number(value);
      sums[column] = sums[col1] !== 0 ? sums[col2] / sums[col1] : 0;
      return value;
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  methods: _objectSpread({}, (0, _vuex.mapActions)('selections', ['updateFormData', 'loadFormData']), {
    resetForm: function resetForm() {
      this.$refs['ElForm'].resetFields();
      this.rptData = [];
      this.secteursact = [];
      this.clients = [];
      this.enseignes = [];
      this.secteursgeo = [];
      this.conducteur = null;
      this.status = [];
      this.currentDate = this.saveDate;
      this.sums = [];
      this.show = false;
      this.refresh++;
    },
    validateForm: function validateForm() {
      var _this3 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          /*
          console.log('-------------------------------------')
          console.log('secteursact', this.secteursact)
          console.log('clients', this.clients)
          console.log('enseignes', this.enseignes)
          console.log('secteursgeo', this.secteursgeo)
          console.log('conducteur', this.conducteur)
          console.log('etape, status', CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value, this.status)
          console.log('date', this.date)
          */
          _this3.show = false;

          _this3.$loader(true);

          var data = {
            etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value,
            secteursact: _this3.secteursact,
            clients: _this3.clients,
            enseignes: _this3.enseignes,
            secteursgeo: _this3.secteursgeo,
            conducteur: _this3.conducteur ? _this3.conducteur.id : null,
            status: _this3.status,
            date: (0, _moment.default)(_this3.currentDate, 'YYYYMM').add(1, 'months').format('YYYYMM'),
            id_societe: _this3.user.id_societe
          };
          apiAffaire.rptFaePca(data).then(function (results) {
            _this3.sums = [];
            _this3.rptData = results;
            _this3.show = true;
          }).then(function () {
            // sauvegarde les filtres dans le localStorage
            data.date = _this3.currentDate;

            _this3.updateFormData({
              pageKey: "".concat(_this3.user.id_societe, "-").concat(_this3.$route.name),
              data: data
            });
          }).finally(function () {
            _this3.refresh++;

            _this3.$loader(false);
          });
        }
      });
    },
    getSummaries: function getSummaries(param) {
      var _this4 = this;

      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        /*
        if (index === 0) {
          sums[index] = `Nb affaires: ${this.rptData.length}`
          return
        }
        */
        if (index === 2) {
          sums[index] = 'TOTAL GENERAL';
          return;
        }

        if (column.property !== undefined && ![0, 1, 2].includes(index)) {
          var value = _this4.sums[column.property] ? _this4.sums[column.property] : 0;

          if (column.property.substring(0, 2) === 'pc') {
            sums[index] = _vue.default.filter('toPercentage')(value);
          } else {
            sums[index] = _vue.default.filter('toCurrency')(value);
          }
        }
      });
      return sums;
    },
    // ==================
    // Export excel
    // ==================
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var workbook, title, style, worksheet, columnHeaderList, cellStart, cellEnd, rowCount, buffer, now, fileType, fileName, fileExtension, file, blob;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Classeur Excel
                workbook = new Excel.Workbook();
                title = 'FAE PCA'; // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFa4c8ff'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // ligne des totaux
                  totaux: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFf5f7fa'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'right'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FF000000'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                }; // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date();
                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = "Export ".concat(title);
                workbook.subject = '';
                workbook.keywords = this.manager;
                workbook.category = '';
                workbook.description = "Rapport : ".concat(title); // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet(title, {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets apres la 2ieme ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 2
                  }]
                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Recherche des entetes colonnes d'en-tête

                columnHeaderList = this.getColumnHeaderList(); // Ajout des entetes de colonnes sur la 1ere lignes (colonnes fusionnées)

                cellStart = 0;
                cellEnd = 0; // --

                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'fae_pca');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'fae_pca');

                if (cellStart && cellEnd) {
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Gestion des FAE et PCA';
                } // ajout des entetes de colonnes sur la 2ieme lignes


                worksheet.getRow(2).values = columnHeaderList.map(function (x) {
                  return x.header;
                }); // Définition des colonnes d'en-tête

                worksheet.columns = columnHeaderList.map(function (x) {
                  return {
                    key: x.key,
                    width: x.width
                  };
                }); // Ajout filtres automatiques sur la 2ieme lignes, colonne 1 et 2

                worksheet.autoFilter = 'A2:B2'; // Données

                worksheet.addRows(this.getPreparedDataForExport()); // Totaux sur la derniere ligne

                rowCount = worksheet.rowCount + 1;
                worksheet.getCell("A".concat(rowCount)).style = _objectSpread({}, style.totaux);
                worksheet.getCell("B".concat(rowCount)).style = _objectSpread({}, style.totaux);
                worksheet.getCell("C".concat(rowCount)).style = _objectSpread({}, style.totaux);
                worksheet.getCell("D".concat(rowCount)).value = {
                  formula: "SUM(D3:D".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("D".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("E".concat(rowCount)).value = {
                  formula: "SUM(E3:E".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("E".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("F".concat(rowCount)).value = {
                  formula: "SUM(F3:F".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("F".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("G".concat(rowCount)).value = {
                  formula: "SUM(G3:G".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("G".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("H".concat(rowCount)).value = {
                  formula: "SUM(H3:H".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("H".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux);
                worksheet.getCell("I".concat(rowCount)).value = {
                  formula: "SUM(I3:I".concat(rowCount - 1, ")"),
                  date1904: false
                };
                worksheet.getCell("I".concat(rowCount)).style = _objectSpread({
                  numFmt: '# ### ##0.00 "€"'
                }, style.totaux); // Boucle sur les lignes de la feuille du classeur

                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Lignes d'en-tête
                      case 1: // ligne 1

                      case 2:
                        // ligne 2
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Données

                      default:
                        var columnStyle = columnHeaderList[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                }); // Ecriture dans un nouveau buffer

                _context2.next = 44;
                return workbook.xlsx.writeBuffer();

              case 44:
                buffer = _context2.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = 'Rapport-FAE-PCA';
                fileExtension = 'xlsx';
                file = "".concat(now, "-").concat(fileName, ".").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file);

              case 52:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getColumnHeaderList: function getColumnHeaderList() {
      var defaultStyles = {
        texte: {
          alignment: {
            vertical: 'top'
          }
        },
        monetaire: {
          numFmt: '# ### ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00 %',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [// Affaire
      {
        header: 'Code Affaire',
        key: 'num_affaire',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Enseigne',
        key: 'libelle_enseigne',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'Nom affaire',
        key: 'nom',
        width: 30,
        style: defaultStyles.texte
      }, {
        header: 'PM mensuel',
        group: 'fae_pca',
        key: 'mt_PM_mens',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'PM cumulé',
        group: 'fae_pca',
        key: 'mt_PM_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'Facturé mensuel',
        group: 'fae_pca',
        key: 'mt_Fact_mens',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'Facturé cumulé',
        group: 'fae_pca',
        key: 'mt_Fact_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'PCA cumulé',
        group: 'fae_pca',
        key: 'mt_PCA_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }, {
        header: 'FA cumulé',
        group: 'fae_pca',
        key: 'mt_FAE_cumule',
        width: 15,
        style: defaultStyles.monetaire
      }];
      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnHeaderList.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderList;
    },
    getFirstColumnHeaderByGroup: function getFirstColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeaderByGroup: function getLastColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getPreparedDataForExport: function getPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      var data = this.rptData;
      data.forEach(function (row) {
        row.mt_PM_mens = parseFloat(row.mtPmPrixDeVente - row.mtPmPrixDeVenteMmoins1);
        row.mt_PM_cumule = parseFloat(row.mtPmPrixDeVente);
        row.mt_Fact_mens = parseFloat(row.mtFacturationClient);
        row.mt_Fact_cumule = parseFloat(row.mtCumulFacturationClientM);
        var mtPCAcumule = Number(row.mtCumulFacturationClientM) > Number(row.mtPmPrixDeVente) ? row.mtCumulFacturationClientM - row.mtPmPrixDeVente : 0;
        row.mt_PCA_cumule = parseFloat(mtPCAcumule);
        var mtFAEcumule = Number(row.mtPmPrixDeVente) > Number(row.mtCumulFacturationClientM) ? row.mtPmPrixDeVente - row.mtCumulFacturationClientM : 0;
        row.mt_FAE_cumule = parseFloat(mtFAEcumule);
      });
      return data;
    }
  })
};
exports.default = _default;